export enum StpUserStatusEnum {
  OnGoing = 1,
  Completed = 3
}